import { RE2JS } from 're2js';
import { AssetItem } from 'Api/Contracts/Dtos/Project/Assets';

export class EventAction {
    public constructor(
        actionName: string,
        name: string,
        description: string,
        callToAction: string,
        regex: RegExp | string,
        linkWithAssetType: Array<any> = null
    ) {
        this.actionName = actionName;
        this.name = name;
        this.description = description;
        this.callToAction = callToAction;
        this.regex = regex;
        this.linkWithAssetType = linkWithAssetType;
    }

    public parseAction(action: string, assetItem?: AssetItem): boolean {
        return false;
    }

    public toString(assetItem?: AssetItem): string {
        return '';
    }

    public isValid(): boolean {
        return false;
    }

    protected getArguments(action: string): Array<any> {
        if (EventAction._isNativeRegExp(this.regex)) {
            return this.regex.exec(action);
        }

        const reg: RE2JS = RE2JS.compile(this.regex, RE2JS.DOTALL);
        const matcher = reg.matcher(action);

        return matcher.find()
            ? Array.from(Array(reg.groupCount() + 1))
                .map((_, index) => matcher.group(index))
            : [];
    }

    private static _isNativeRegExp(regex: RegExp | string): regex is RegExp {
        return typeof regex !== 'string';
    }

    public actionName: string;
    public name: string;
    public description: string;
    public callToAction: string;
    public regex: RegExp | string;
    public linkWithAssetType: Array<any>;

    public static readonly hotspotAvailableEvents: Array<{ key: string; eventName: string; }> = [
        { key: 'Clic', eventName: 'onClick' },
        //'Double clic',
        //'Mouse Enter',
        //'Mouse Leave',
        //'Enter in frustum',
        //'Leave frustum',
        //'Double clic',
        //'Drag enter',
        //'Drag leave',
        //'Drag over',
        //'Drop',
        //'Key Down',
        //'Key Up',
        //'Loaded',
        //'Mouse Down',
        //'Clic Gauche Down',
        //'Clic Gauche Up',
        //'Clic Droit Down',
        //'Clic Droit Up',
        //'Expanded'
    ];

    public static readonly projectAvailableEvents: Array<{ key: string; eventName: string; }> = [
        { key: 'Loaded', eventName: 'onLoaded' },
    ];

    public static readonly panoramaGroupAvailableEvents: Array<{ key: string; eventName: string; }> = [
        { key: 'Loaded', eventName: 'onLoaded' },
    ];

    public static readonly panoramaVersionAvailableEvents: Array<{ key: string; eventName: string; }> = [
        { key: 'Loaded', eventName: 'onLoaded' },
    ];
}
